// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__38sJC","label":"SetPasswdForm_label__1HMoG"};